const viewportMapping = {
  "sm": 600,
  "md": 900,
  "lg": 1200,
};

export default viewportMapping;
